import App from '../App.tsx'
import {
  createBrowserRouter,
} from "react-router-dom"
import { Home3 } from '../pages/home3/index.tsx'
import { Fantui } from '../pages/fantui/index.tsx'
import { Huaci } from '../pages/huaci/index.tsx'
import { Hepan } from '../pages/hepan/index.tsx'
import { HealthPage } from '../pages/health/index.tsx'
import { CareerPage } from '../pages/career/index.tsx'
import { TalentKidPage } from '../pages/talent-kid/index.tsx'
import { MarriagePage } from '../pages/marriage/index.tsx'
import { LitePage } from '../pages/lite/index.tsx'
import { TopicHubPage } from '../pages/topic-hub/index.tsx'
import { VedicPage } from "../pages/vedic/index.tsx"
import { siteConfig } from '../config/site.ts'

const rootElement = siteConfig.features.showLiteAsHome ? <LitePage /> : <App />;

export const router = createBrowserRouter([
  {
    path: "/",
    element: rootElement,
  },
  {
    path: "/fantui",
    element: <Fantui />,
  },
  {
    path: "/home2",
    element: <Home3 />,
  },
  {
    path: "/fenci",
    element: <Huaci />,
  },
  {
    path: "/hepan",
    element: <Hepan />,
  },
  {
    path: "/health",
    element: <HealthPage />,
  },
  {
    path: "/career",
    element: <CareerPage />,
  },
  {
    path: "/talent-kid",
    element: <TalentKidPage />,
  },
  {
    path: "/marriage",
    element: <MarriagePage />,
  },
  {
    path: "/lite",
    element: <LitePage />,
  },
  {
    path: "/topics",
    element: <TopicHubPage />,
  },
  {
    path: "/vedic",
    element: <VedicPage />,
  }
]);
